/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { dashboardStatsSchema } from "./dashboardStatsSchema.ts";

export const dashboardStatsRetrieveQueryDateFromSchema = z.string().optional().describe("Начало диапазона (ISO 8601, например 2025-01-01T00:00:00)");

export const dashboardStatsRetrieveQueryDateToSchema = z.string().optional().describe("Конец диапазона (ISO 8601, например 2025-12-31T23:59:59)");

export const dashboardStatsRetrieveQueryGroupBySchema = z
	.enum(["org_unit", "organization"])
	.optional()
	.default("organization")
	.describe("Разрез статистики: organization (по организациям) или org_unit (по точкам организации)");

export const dashboardStatsRetrieveQueryIncludeDeviceSchema = z.boolean().optional().describe("Включить блок device (киоск) в ответ");

export const dashboardStatsRetrieveQueryIncludeQrMenuSchema = z.boolean().optional().describe("Включить блок qr_menu (без киоска) в ответ");

export const dashboardStatsRetrieveQueryPeriodSchema = z
	.enum(["day", "month", "week"])
	.optional()
	.describe(
		"Разбивка показателей блоков по времени в часовом поясе точки: day (по дням), week (по неделям, с понедельника), month (по месяцам). Без параметра разбивки нет",
	);

export const dashboardStatsRetrieveQuerySortTopBySchema = z
	.enum(["avg_check", "order_count", "total_sum"])
	.optional()
	.default("order_count")
	.describe("Сортировка топа организаций/точек: order_count (по кол-ву заказов), total_sum (по сумме), avg_check (по среднему чеку)");

export const dashboardStatsRetrieveStatus200Schema = dashboardStatsSchema;

export const dashboardStatsRetrieveResponseSchema = dashboardStatsRetrieveStatus200Schema;
